import { actionType } from './actions';

const initialState = {
    user: null,
    fetching: false,
    fetched: false,
    error: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionType.REQUESTED_AUTHENTICATION_DATA: {
            return {
                ...state,
                fetching: true,
                fetched: false,
                error: false
            };
        }

        case actionType.REJECTED_AUTHENTICATION_DATA: {
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: true
            };
        }

        case actionType.LOGIN: {
            return {
                ...state,
                user: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.LOGOUT: {
            return {
                ...state,
                user: null,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.IS_AUTHENTICATED: {
            return {
                ...state,
                user: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/services/redux/authentication/reducers.js